// New component: ModalConfirmReview.tsx
import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import ButtonDefault from '@/components/ui/ButtonDefault';
import * as S from './styles';

interface ModalConfirmReviewProps {
	id: string;
	open?: boolean;
	onCancel: () => void;
	onConfirm: (id: string) => void;
}

export function ModalConfirmReview({
	id,
	open = false,
	onCancel,
	onConfirm
}: Readonly<ModalConfirmReviewProps>): JSX.Element {
	function handleOnConfirm(): void {
		onConfirm(id);
	}

	return (
		<S.ModalStyled width={500} footer={null} open={open} onCancel={onCancel} centered closable={true}>
			<Row justify="center">
				<ExclamationCircleOutlined
					style={{
						color: '#2F54EB',
						fontSize: 70
					}}
				/>
			</Row>
			<Row justify="center">
				<Col span={20} style={{ marginTop: 10 }}>
					<S.CustomConfirmMessage>
						{I18n.get(
							'Once a new review is created, the current version will no longer be editable. Do you wish to continue?'
						)}
					</S.CustomConfirmMessage>
				</Col>
			</Row>
			<Row justify="center" style={{ marginTop: 20 }}>
				<ButtonDefault key="back" onClick={onCancel} style={{ marginRight: 10 }}>
					{I18n.get('Cancel')}
				</ButtonDefault>
				<ButtonDefault type="primary" onClick={handleOnConfirm} style={{ marginLeft: 10 }}>
					{I18n.get('Continue')}
				</ButtonDefault>
			</Row>
		</S.ModalStyled>
	);
}
